<template>
  <div>
    <div class="popup" :class="{'visible-mobile': isMobile}">  <!-- if only mobile - add class "visible-mobile"-->
      <div class="modalContent">
        <div class="closeBlock">
          <i class="close" @click="close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="#526C82" fill-opacity="0.8"/>
            </svg>
          </i>
        </div>
        <div class="modal_titleForm">{{ $t('renew_enter_qid') }}</div>
        <UserIdForm
          :value="value"
          @input="$emit('input', $event)"
          @onSubmit="onSubmit"/>
      </div>
    </div>
    <div class="bgPopup" @click="close"></div>
  </div>
</template>

<script>
import UserIdForm from '@/components/UserIdForm'

const mobileMediaQuery = '(max-width: 550px)'
const mediaQueryList = matchMedia(mobileMediaQuery)

export default {
  props: {
    value: String
  },
  components: {
    UserIdForm
  },
  data: () => ({
    loading: false,
    errorMessage: null,
    passport: null,
    isMobile: false
  }),
  methods: {
    close () {
      this.$emit('close')
    },
    onSubmit () {
      this.$emit('onSubmit')
    },
    handleResize (event) {
      this.isMobile = event.matches
    }
  },

  mounted () {
    mediaQueryList.addEventListener('change', this.handleResize)
  },
  beforeDestroy () {
    mediaQueryList.removeEventListener('change', this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
.popup {
  max-height: 100vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar{
    height: 0;
    width: 0;
    display: none;
  }
}
</style>
